import { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { isInvalidDate, cleanSpecialNaming } from "../HelperFx/common";
import {
  DeleteBCLines,
  companyDefault,
  base64bactokenkendtoken,
} from "../HelperFx/datalinks";
import ErrorMessage from "./ErrorPopup";
import SuccessMessage from "./SuccessPopup";
import ConfirmationDialog from "./Confirmation";
import axios from "axios";

import "./Datatable.css";
import { token } from "../HelperFx/datalinks";

const ExpandedComponent = ({ data }) => (
  <pre>{JSON.stringify(data, null, 2)}</pre>
);
const EditableDatable = ({
  columns,
  initialData,
  pageOnBlur,
  universalDisabled = false,
  linesApi,
  converteddocType,
  ShowActions = false,
}) => {
  const [fetchedData, setData] = useState(initialData || []);
  const [confirmConfiguration, setConfirmConfiguration] = useState({});
  const [popupMsg, setPopupMsg] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [ErrorMsg, setErrorMessage] = useState("");
  const [confirmedOpen, setConfirmedOpen] = useState(false);
  const [issuccedOpen, setSucceededOpen] = useState(false);
  const [isErrOpen, setErrorOpen] = useState(false);

  const customStyles = {
    head: {
      style: {
        fontSize: "14px",
        fontWeight: 600,
        backgroundColor: "#f8fafc",
        color: "#334155",
      },
    },

    headRow: {
      style: {
        borderBottomWidth: "1px",
        borderBottomColor: "#e2e8f0",
        borderTopWidth: "1px",
        borderTopColor: "#e2e8f0",
        margin: "0px",
        padding: "0px",
      },
    },

    rows: {
      style: {
        fontSize: "13px",
        color: "#334155",
        "&:not(:last-of-type)": {
          borderBottomWidth: "1px",
          borderBottomColor: "#e2e8f0",
        },
        "&:hover": {
          backgroundColor: "#f8fafc",
        },
        margin: "0px",
        minHeight: "32px",
      },
    },
    cells: {
      style: {
        paddingTop: "0px",
        paddingBottom: "0px",
        paddingLeft: "0px",
        paddingRight: "0px",
      },
    },
  };

  // useEffect(()=>{})
  const createEmptyRow = (idSuffix) => ({
    systemId: `empty-${idSuffix}-${Date.now()}`, // unique id
  });

  const DeleteAllLines = async () => {
    try {
      const uniquedata = {
        docNo: `${fetchedData[0].documentNo}`,
        docType: `${converteddocType}`,
      };
      console.log(uniquedata);
      const response = await axios.post(DeleteBCLines, uniquedata, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${token}`,
        },
      });
      setPopupMsg(
        typeof response.data === "object"
          ? JSON.stringify(response.data.value, null, 2)
          : response.data || "Request sent successfully.",
      );
      setSucceededOpen(true);
      // refreshing
      window.location.reload();

      // console.log(response);
    } catch (err) {
      const backendMessage = err.response?.data?.error?.message;
      setErrorMessage(
        backendMessage ||
          err.message ||
          "An error occurred while deleting the document.",
      );
      // setErrorOpen(true);
    }
  };
  const DeleteSelectedLines = async () => {
    if (selectedRows.length === 0) {
      setPopupMsg("No rows selected for deletion.");
      setSucceededOpen(true);

      return;
    }
    try {
      for (const sysId of selectedRows) {
        await axios.delete(`${linesApi}(${sysId})?${companyDefault}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${token}`,
          },
        });
      }
      setPopupMsg("Lines selected successfully");
      setSucceededOpen(true);
      // refreshing
      window.location.reload();
    } catch (err) {
      const backendMessage = err.response?.data?.error?.message;
      setErrorMessage(
        backendMessage ||
          err.message ||
          "An error occurred while deleting the document.",
      );
      // setErrorOpen(true);
    }
  };

  useEffect(() => {
    const baseData = Array.isArray(initialData)
      ? initialData
      : initialData
        ? [initialData]
        : [];
    const filteredData = baseData.filter(
      (row) => Object.keys(row).length > 1, // keep rows with more than just systemId
    );
    let withEmptyRows = [...filteredData];

    // ✅ Only add empty rows if universalDisabled is false
    if (!universalDisabled) {
      withEmptyRows = [...withEmptyRows, createEmptyRow(1), createEmptyRow(2)];
    }
    setData(withEmptyRows);
  }, [initialData]);

  // const handleSelectedRowsChange = ({ selectedRows }) => {
  //   console.log(selectedRows);
  //   setSelectedRows(
  //       selectedRows.map(row => {
  //           // If systemId begins with "empty", replace with systemSerialId
  //           return row.systemId && row.systemId.toLowerCase().startsWith("empty")
  //               ? row.systemSerialId
  //               : row.systemId;
  //       })
  //   );
  // };
  const handleSelectedRowsChange = ({ selectedRows }) => {
    // console.log(selectedRows);
    const systemIds = selectedRows
      .filter((row) => {
        // Skip rows where systemId starts with "empty" and systemSerialId is missing
        if (!row.systemId) return false;
        if (
          row.systemId.toLowerCase().startsWith("empty") &&
          !row.systemSerialId
        )
          return false;
        return true;
      })
      .map((row) => {
        return row.systemId.toLowerCase().startsWith("empty")
          ? row.systemSerialId
          : row.systemId;
      });

    setSelectedRows(systemIds);
    console.log(systemIds);
    console.log(selectedRows);
  };

  // console.log(selectedRows);
  const handleInputChange = (id, field, value) => {
    const updated = fetchedData.map((row) =>
      row.systemId === id ? { ...row, [field]: value } : row,
    );
    setData(updated);
  };

  const handleInputBlur = (id, field, value) => {
    if (
      id.startsWith("empty") &&
      (value === undefined || value === null || value === "")
    )
      return;

    if (id.startsWith("empty")) {
      const temprow = initialData.find((r) => r.systemId === id);
      if (temprow && temprow[field] === value) return;
    }

    // Skip if existing row and value hasn't changed
    if (!id.startsWith("empty")) {
      const temprow = initialData.find((r) => r.systemId === id);
      if (temprow && temprow[field] === value) return;
    }

    const updated = fetchedData.map((row) =>
      row.systemId === id ? { ...row, [field]: value } : row,
    );
    if (typeof pageOnBlur === "function") {
      pageOnBlur(id, field, value, updated);
      setData(updated);
    }
  };

  const fcolumn = {
    name: "",
    selector: (row) => row.selected,
    width: "20px",
    sortable: false,
  };

  const enhancedColumns = columns.map((col) => ({
    name: col.label,
    sortable: col.sortable,
    minWidth: col.width,
    grow: col.grow,
    cell: (row) => {
      const value = row[col.name] ?? "";
      const isDisabled = universalDisabled || col.disabled;

      switch (col.type) {
        case "checkbox":
          return (
            <span className="table-input-cust">
              <input
                type="checkbox"
                checked={!!value}
                tabIndex={col.tabIndex}
                onChange={(e) =>
                  handleInputChange(row.systemId, col.name, e.target.checked)
                }
                onBlur={(e) =>
                  handleInputBlur(row.systemId, col.name, e.target.checked)
                }
                disabled={isDisabled}
              />
            </span>
          );

        case "select":
          return (
            <select
              value={value}
              tabIndex={col.tabIndex}
              className="table-input-cust"
              onChange={(e) =>
                handleInputChange(row.systemId, col.name, e.target.value)
              }
              onBlur={(e) =>
                handleInputBlur(row.systemId, col.name, e.target.value)
              }
              disabled={isDisabled}
            >
              <option value=""></option>
              {col.options?.map((opt, idx) => (
                <option key={idx} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          );
        case "date": {
          const safeDate = !value || isInvalidDate(value) ? "" : value;
          return (
            <input
              type="date"
              value={safeDate}
              tabIndex={col.tabIndex}
              className="table-input-cust"
              onChange={(e) =>
                handleInputChange(row.systemId, col.name, e.target.value)
              }
              onBlur={(e) =>
                handleInputBlur(row.systemId, col.name, e.target.value)
              }
              onFocus={(e) => {
                // If empty, set to today on focus
                if (!e.target.value || isInvalidDate(e.target.value)) {
                  const today = new Date();
                  const todayStr = today.toISOString().split("T")[0];
                  handleInputChange(row.systemId, col.name, todayStr);
                }
              }}
              disabled={isDisabled}
            />
          );
        }
        case "decimal":
          return (
            <input
              type="number"
              value={value}
              tabIndex={col.tabIndex}
              className="table-input-cust"
              onChange={(e) => {
                const floatValue = parseFloat(e.target.value) || "";
                handleInputChange(row.systemId, col.name, floatValue);
              }}
              onBlur={(e) => {
                const floatValue = parseFloat(e.target.value) || "";
                handleInputBlur(row.systemId, col.name, floatValue);
              }}
              disabled={isDisabled}
            />
          );
        case "integer":
          return (
            <input
              type="number"
              value={value}
              tabIndex={col.tabIndex}
              className="table-input-cust"
              onChange={(e) => {
                const intValue =
                  e.target.value === ""
                    ? 0
                    : parseInt(e.target.value, 10) || "";
                handleInputChange(row.systemId, col.name, intValue);
              }}
              onBlur={(e) => {
                const intValue =
                  e.target.value === ""
                    ? 0
                    : parseInt(e.target.value, 10) || "";
                handleInputBlur(row.systemId, col.name, intValue);
              }}
              disabled={isDisabled}
            />
          );
        case "time":
        case "datetime-local":
        case "text":
        default:
          return (
            <input
              type={col.type}
              value={value}
              tabIndex={col.tabIndex}
              className="table-input-cust"
              onChange={(e) =>
                handleInputChange(row.systemId, col.name, e.target.value)
              }
              onBlur={(e) =>
                handleInputBlur(row.systemId, col.name, e.target.value)
              }
              disabled={isDisabled}
            />
          );
      }
    },
  }));

  const finalColumns = [fcolumn, ...enhancedColumns];

  return (
    <div style={{ minHeight: "40px", overflowX: "scroll", margin: "10px" }}>
      {/* Customize so that they only show up for pending documents */}
      {ShowActions && (
        <div
          style={{
            b: "6px 0px",
            marginBottom: "10px",
            marginTop: "5px",
            paddingBottom: "10px",
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            backgroundColor: "white",
          }}
        >
          <button
            type="button"
            style={{
              padding: "4px 8px",
              border: "1.25px solid maroon",
              borderRadius: "4px",
              color: "grey",
              cursor: "pointer",
            }}
            onClick={() => {
              setConfirmConfiguration({
                caption: "Delete Selected lines",
                message: "Are you sure you want to delete selected lines?",
                onConfirm: DeleteSelectedLines,
              });
              setConfirmedOpen(true);
            }}
          >
            Delete Selected Lines
          </button>
          <button
            type="button"
            style={{
              padding: "4px 8px",
              border: "1.25px solid maroon",
              borderRadius: "4px",
              color: "grey",
              cursor: "pointer",
            }}
            onClick={() => {
              setConfirmConfiguration({
                caption: "Delete Selected lines",
                message: "Are you sure you want to delete the all lines?",
                onConfirm: DeleteAllLines,
              });
              setConfirmedOpen(true);
            }}
          >
            Delete All Lines
          </button>
        </div>
      )}
      {ErrorMsg && (
        <div
          style={{
            padding: "15px",
            marginBottom: "10px",
            marginTop: "10px",
            paddingBottom: "10px",
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            backgroundColor: "white",
            color: "red",
          }}
        >
          {ErrorMsg}
        </div>
      )}
      <DataTable
        className="ModifiedDatatable"
        columns={finalColumns}
        data={fetchedData}
        customStyles={customStyles}
        fixedHeader
        fixedHeaderScrollHeight="calc(100vh - 300px)"
        selectableRows
        responsive
        pagination
        // expandableRows
        // expandableRowsComponent={ExpandedComponent}
        onSelectedRowsChange={handleSelectedRowsChange}
        noDataComponent={
          <div className="p-4 text-center text-gray-500">No Data found</div>
        }
      />
      <ConfirmationDialog
        isOpen={confirmedOpen}
        toggle={() => setConfirmedOpen(!confirmedOpen)}
        caption={confirmConfiguration.caption}
        message={confirmConfiguration.message}
        onConfirm={() => {
          confirmConfiguration.onConfirm();
          setConfirmedOpen(false);
        }}
      />

      <SuccessMessage
        isOpen={issuccedOpen}
        toggle={() => setSucceededOpen(!issuccedOpen)}
        caption="Success"
        message={popupMsg}
      />

      <ErrorMessage
        isOpen={isErrOpen}
        toggle={() => setErrorOpen(!isErrOpen)}
        caption="Error"
        message={popupMsg}
      />
    </div>
  );
};

export default EditableDatable;
